import { Button } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React from 'react'

export const TableRow = (props) => {
  const { name, identify, phone, onShowUserAmount, createdAt, amount, lastBuyTicketAt, assignPin, id, address, trackLogin } = props;

  return (
    <tr className='text-center'>
      <td>
        <Button variant={amount === null ? "danger" : "info"} className="m-1" onClick={() => onShowUserAmount(id)}>Xem tài khoản</Button>
        <Button className="m-1" variant="success" type="submit" onClick={() => assignPin(id)}>Cấp mã pin</Button>
        <Button className="m-1" variant="primary" type="button" onClick={() => trackLogin(id)}>Xem phiên đăng nhập</Button>
      </td>
      <td className='text-left'>
        <b style={{fontSize: 20}}>{name || ""}</b><br />
        <span className={`fw-900`}><b>CCCD:</b> {identify || ""}</span><br />
        <span className={`fw-900`}><b>Đ/C:</b> {address || ""}</span>
      </td>
      <td><strong className={`fw-bold`}>{phone}</strong></td>
      <td>
        {moment(lastBuyTicketAt || '').format('DD/MM/YYYY HH:mm:ss')}
      </td>
      <td>
        {moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}
      </td>
    </tr>
  );
};